import React, { useState } from 'react';
import './App.css';
import { PhoneIcon, MapPinIcon } from '@heroicons/react/24/solid';

function App() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Preparar a mensagem para o WhatsApp
    const message = `Olá! Sou ${formData.nome}. 
Email: ${formData.email}
Telefone: ${formData.telefone}
Mensagem: ${formData.mensagem}`;
    
    // Codificar a mensagem para URL
    const encodedMessage = encodeURIComponent(message);
    
    // Abrir WhatsApp com a mensagem
    window.open(`https://wa.me/5585996990500?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="font-sans">
      {/* Header */}
      <header className="bg-jmc-green-dark text-white">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center">
            <img src="/images/Logo JMC.jpeg" alt="JMC Madeiras Logo" className="h-16 mr-3" />
            <div className="text-2xl font-serif font-bold">Depósito JMC</div>
          </div>
          <div className="hidden md:flex space-x-6">
            <a href="#sobre" className="hover:text-jmc-cream">Sobre</a>
            <a href="#produtos" className="hover:text-jmc-cream">Produtos</a>
            <a href="#servicos" className="hover:text-jmc-cream">Serviços</a>
            <a href="#contato" className="hover:text-jmc-cream">Contato</a>
          </div>
          <div className="flex items-center">
            <PhoneIcon className="h-5 w-5 mr-2" />
            <span>(85) 99699-0500</span>
          </div>
        </div>
      </header>

      {/* Banner Principal */}
      <section className="bg-jmc-green-medium text-white py-16 relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10 flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <h1 className="text-4xl md:text-5xl font-serif mb-4">Depósito JMC</h1>
            <h2 className="text-2xl md:text-3xl font-serif mb-6">Mais de 25 anos construindo com você!</h2>
            <p className="text-lg mb-8">Material de construção em geral e madeiramento de qualidade</p>
            <a href="#contato" className="bg-jmc-wood text-jmc-green-dark font-bold py-3 px-6 rounded-lg hover:bg-opacity-90 transition duration-300">
              FAÇA SEU ORÇAMENTO
            </a>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <img src="/images/Logo Insta.jpeg" alt="JMC Madeiras Banner" className="rounded-lg shadow-xl max-w-full h-auto" />
          </div>
        </div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-jmc-green-dark to-transparent"></div>
        </div>
      </section>

      {/* Sobre */}
      <section id="sobre" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">Sobre a JMC Madeiras</h2>
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <div className="bg-jmc-green-dark p-1 rounded-lg">
                <div className="bg-jmc-wood p-8 rounded-lg">
                  <p className="text-xl font-serif text-jmc-green-dark">
                    Com mais de 25 anos no mercado, o Depósito JMC se destaca pela qualidade dos produtos e excelência no atendimento.
                  </p>
                </div>
              </div>
              <div className="mt-6">
                <img 
                  src="/images/Geraçoes.jpg" 
                  alt="Gerações JMC Madeiras" 
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            </div>
            <div className="md:w-1/2 md:pl-8">
              <p className="mb-4">
                Somos especializados em madeiramento e materiais de construção, oferecendo as melhores soluções para seus projetos.
              </p>
              <p className="mb-4">
                Nossa missão é fornecer produtos de alta qualidade, com preços justos e atendimento personalizado.
              </p>
              <p className="mb-4">
                Contamos com uma equipe experiente e comprometida em ajudar você a realizar seus sonhos.
              </p>
              <p>
                Unindo gerações, da nossa família para a sua!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Produtos */}
      <section id="produtos" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">Nossos Produtos</h2>
          
          <div className="mb-12">
            <h3 className="text-2xl font-serif text-jmc-green-dark mb-6">Madeiramento</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/maçaranduba.jpeg" 
                  alt="Madeira Maçaranduba" 
                  className="w-full h-48 object-cover"
                />
                <div className="bg-jmc-green-medium h-2"></div>
                <div className="p-6">
                  <h4 className="text-xl font-serif text-jmc-green-dark mb-2">Maçaranduba</h4>
                  <p className="text-gray-600">Madeira de alta qualidade para diversos tipos de projetos.</p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/Tabuas muiracatiara.jpeg" 
                  alt="Madeira Muiracatiara" 
                  className="w-full h-48 object-cover"
                />
                <div className="bg-jmc-green-medium h-2"></div>
                <div className="p-6">
                  <h4 className="text-xl font-serif text-jmc-green-dark mb-2">Muiracatiara</h4>
                  <p className="text-gray-600">Madeira de alta qualidade para diversos tipos de projetos.</p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/Eucaliptos.jpeg" 
                  alt="Madeira Eucalipto" 
                  className="w-full h-48 object-cover"
                />
                <div className="bg-jmc-green-medium h-2"></div>
                <div className="p-6">
                  <h4 className="text-xl font-serif text-jmc-green-dark mb-2">Eucalipto</h4>
                  <p className="text-gray-600">Madeira de alta qualidade para diversos tipos de projetos.</p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img 
                  src="/images/Tabua pinus.jpeg" 
                  alt="Madeira Pinus" 
                  className="w-full h-48 object-cover"
                />
                <div className="bg-jmc-green-medium h-2"></div>
                <div className="p-6">
                  <h4 className="text-xl font-serif text-jmc-green-dark mb-2">Pinus</h4>
                  <p className="text-gray-600">Madeira de alta qualidade para diversos tipos de projetos.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-serif text-jmc-green-dark mb-6">Materiais em Madeira que trabalhamos</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-jmc-wood rounded-full py-3 px-6 text-center">
                  <span className="text-jmc-green-dark font-bold">Ripas</span>
                </div>
                <img 
                  src="/images/ripas.jpg" 
                  alt="Ripas de madeira" 
                  className="w-full h-48 object-cover mt-2"
                />
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-jmc-wood rounded-full py-3 px-6 text-center">
                  <span className="text-jmc-green-dark font-bold">Caibros</span>
                </div>
                <img 
                  src="/images/caibros.jpg" 
                  alt="Caibros de madeira" 
                  className="w-full h-48 object-cover mt-2"
                />
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-jmc-wood rounded-full py-3 px-6 text-center">
                  <span className="text-jmc-green-dark font-bold">Móveis</span>
                </div>
                <img 
                  src="/images/moveis.jpg" 
                  alt="Móveis de madeira" 
                  className="w-full h-48 object-cover mt-2"
                />
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-jmc-wood rounded-full py-3 px-6 text-center">
                  <span className="text-jmc-green-dark font-bold">Portas</span>
                </div>
                <img 
                  src="/images/portas.jpg" 
                  alt="Portas de madeira" 
                  className="w-full h-48 object-cover mt-2"
                />
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-jmc-wood rounded-full py-3 px-6 text-center">
                  <span className="text-jmc-green-dark font-bold">Janelas</span>
                </div>
                <img 
                  src="/images/janelas.jpg" 
                  alt="Janelas de madeira" 
                  className="w-full h-48 object-cover mt-2"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section id="servicos" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">Nossos Serviços</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="border-2 border-jmc-green-dark rounded-lg overflow-hidden">
              <img 
                src="/images/4. Material Construçao.jpg" 
                alt="Material de Construção" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 hover:bg-jmc-green-dark hover:text-white transition duration-300">
                <h3 className="text-xl font-serif mb-4">Material de Construção</h3>
                <p>Oferecemos uma ampla variedade de materiais de construção para atender todas as suas necessidades.</p>
              </div>
            </div>
            <div className="border-2 border-jmc-green-dark rounded-lg overflow-hidden">
              <img 
                src="/images/Moveis palnejados.jpg" 
                alt="Móveis Planejados" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 hover:bg-jmc-green-dark hover:text-white transition duration-300">
                <h3 className="text-xl font-serif mb-4">Móveis Planejados</h3>
                <p>Soluções personalizadas que combinam estilo e funcionalidade para o seu lar, feitas sob medida.</p>
              </div>
            </div>
            <div className="border-2 border-jmc-green-dark rounded-lg overflow-hidden">
              <img 
                src="/images/Orçamentos personalisados.jpg" 
                alt="Orçamento Personalizado" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6 hover:bg-jmc-green-dark hover:text-white transition duration-300">
                <h3 className="text-xl font-serif mb-4">Orçamento Personalizado</h3>
                <p>"Aqui é assim: o cliente pediu, a gente faz! Nada de padrão engessado."</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Galeria */}
      <section className="py-16 bg-jmc-cream">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">Galeria de Projetos</h2>
          
          <div className="mb-12">
            <h3 className="text-2xl font-serif text-jmc-green-dark mb-6 text-center">Móveis Planejados</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/moveis/Treliche de maçaranduba.jpg" 
                  alt="Treliche de Maçaranduba" 
                  className="w-full h-48 object-cover rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/moveis/Guarda corpo X.jpg" 
                  alt="Guarda Corpo em X" 
                  className="w-full h-48 object-cover rounded"
                />
              </div>
              {[2, 3, 4, 5, 6, 7].map((num) => (
                <div key={`movel-${num}`} className="bg-white p-2 rounded-lg shadow-md">
                  <img 
                    src={`/images/moveis/${num}.jpg`} 
                    alt={`Móvel Planejado ${num}`} 
                    className="w-full h-48 object-cover rounded"
                  />
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-serif text-jmc-green-dark mb-6 text-center">Produtos em Destaque</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Rend-Mais-NOVO--18L-Balde.png" 
                  alt="Rend Mais 18L" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Telha Fibrocimento.png" 
                  alt="Telha Fibrocimento" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Ceramica Cebras.png" 
                  alt="Cerâmica Cebras" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Massa cola Quartzolit.png" 
                  alt="Massa Cola Quartzolit" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Forro PVC.png" 
                  alt="Forro PVC" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Mangueira Flexivel 25mm.jpg" 
                  alt="Mangueira Flexível 25mm" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Fecahdura Stam.png" 
                  alt="Fechadura Stam" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Madeirites.jpeg" 
                  alt="Madeirites" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/Carro de mao.png" 
                  alt="Carro de Mão" 
                  className="w-full h-48 object-contain rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/20200924_113304.jpg" 
                  alt="Produto em Destaque" 
                  className="w-full h-48 object-cover rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/20200622_132715.jpg" 
                  alt="Produto em Destaque" 
                  className="w-full h-48 object-cover rounded"
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md">
                <img 
                  src="/images/produtos_destaque/20210407_080216.jpg" 
                  alt="Produto em Destaque" 
                  className="w-full h-48 object-cover rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">Nossos Diferenciais</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-serif text-jmc-green-dark mb-4">Personalização</h3>
              <p>Atendimento sob medida, adaptando-se às necessidades específicas de cada cliente.</p>
            </div>
            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-serif text-jmc-green-dark mb-4">Qualidade e Durabilidade</h3>
              <p>"Aqui, não entregamos só janelas – criamos proteção, beleza e um pedaço do seu lar que dura gerações."</p>
            </div>
            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-serif text-jmc-green-dark mb-4">Experiência no Setor</h3>
              <p>Mais de duas décadas de atuação, garantindo expertise e confiança em cada projeto.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif text-jmc-green-dark mb-8 text-center">O que nossos clientes dizem</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <p className="italic mb-4">"Excelente atendimento e produtos de qualidade. Recomendo a todos que precisam de materiais de construção e madeiramento."</p>
              <p className="font-bold">- Maria Silva</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <p className="italic mb-4">"Os móveis planejados ficaram perfeitos! Atendimento personalizado e entrega no prazo. Superou minhas expectativas."</p>
              <p className="font-bold">- João Santos</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contato */}
      <section id="contato" className="py-16 bg-jmc-green-dark text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif mb-8 text-center">Entre em Contato</h2>
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <div className="bg-white text-jmc-green-dark p-6 rounded-lg">
                <div className="flex justify-center mb-6">
                  <img src="/images/Logo JMC.jpeg" alt="JMC Madeiras Logo" className="h-24" />
                </div>
                <h3 className="text-xl font-serif mb-4">Informações de Contato</h3>
                <div className="flex items-center mb-4">
                  <PhoneIcon className="h-5 w-5 mr-2" />
                  <span>(85) 99699-0500</span>
                </div>
                <div className="flex items-center mb-4">
                  <MapPinIcon className="h-5 w-5 mr-2" />
                  <span>Rua Moreira Rocha, Sucatinga/CE</span>
                </div>
                <div className="flex items-center">
                  <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  <span>@jmcmadeiras</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 md:pl-8">
              <form className="bg-white text-gray-800 p-6 rounded-lg" onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-jmc-green-dark mb-2" htmlFor="nome">Nome</label>
                  <input 
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-jmc-green-dark" 
                    type="text" 
                    id="nome" 
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-jmc-green-dark mb-2" htmlFor="email">Email</label>
                  <input 
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-jmc-green-dark" 
                    type="email" 
                    id="email" 
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-jmc-green-dark mb-2" htmlFor="telefone">Telefone</label>
                  <input 
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-jmc-green-dark" 
                    type="tel" 
                    id="telefone" 
                    value={formData.telefone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-jmc-green-dark mb-2" htmlFor="mensagem">Mensagem</label>
                  <textarea 
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-jmc-green-dark" 
                    id="mensagem" 
                    rows="4"
                    value={formData.mensagem}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
                <button 
                  type="submit"
                  className="bg-jmc-green-dark text-white font-bold py-2 px-4 rounded-md hover:bg-opacity-90 transition duration-300 w-full flex items-center justify-center"
                >
                  <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                  </svg>
                  Enviar mensagem pelo WhatsApp
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-jmc-green-dark text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <h3 className="text-2xl font-serif">Depósito JMC</h3>
              <p>Mais de 25 anos construindo com você!</p>
            </div>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/jmcmadeiras/" target="_blank" rel="noopener noreferrer" className="hover:text-jmc-cream">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a href="https://wa.me/5585996990500" target="_blank" rel="noopener noreferrer" className="hover:text-jmc-cream">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                </svg>
              </a>
            </div>
          </div>
          <div className="mt-8 text-center">
            <p>&copy; 2025 Depósito JMC Madeiras. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Botão WhatsApp Flutuante */}
      <a 
        href="https://wa.me/5585996990500" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 text-white rounded-full p-3 shadow-lg hover:bg-green-600 transition duration-300"
      >
        <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </a>
    </div>
  );
}

export default App;
